import { type } from "../../types/types";

export default function reducer(state = { brands: [] }, action) {
  switch (action.type) {
    case type.SET_BRANDS:
      return { ...state, ...action.brands };
    default:
      return state;
  }
}
